"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSignInSignUpRequestForPagesRouter = void 0;
const utils_1 = require("../utils");
const handleSignInSignUpRequestForPagesRouter = ({ request, response, customState, oAuthConfig, userPoolClientId, origin, setCookieOptions, type, }) => {
    const { codeVerifier, state } = (0, utils_1.createAuthFlowProofs)({ customState });
    const redirectUrlSearchParams = (0, utils_1.createUrlSearchParamsForSignInSignUp)({
        url: request.url,
        oAuthConfig,
        userPoolClientId,
        state,
        origin,
        codeVerifier,
    });
    (0, utils_1.appendSetCookieHeadersToNextApiResponse)(response, (0, utils_1.createSignInFlowProofCookies)({ state, pkce: codeVerifier.value }), (0, utils_1.createAuthFlowProofCookiesSetOptions)(setCookieOptions, origin));
    const redirectUrl = type === 'signIn'
        ? (0, utils_1.createAuthorizeEndpoint)(oAuthConfig.domain, redirectUrlSearchParams)
        : (0, utils_1.createSignUpEndpoint)(oAuthConfig.domain, redirectUrlSearchParams);
    response.redirect(302, redirectUrl);
};
exports.handleSignInSignUpRequestForPagesRouter = handleSignInSignUpRequestForPagesRouter;
